import useOrganizations from './useOrganizations';

const useOrganizationById = (organizationId?: number) => {
  const organizations = useOrganizations();
  return organizations.find(organization => organization.id === organizationId);
};

export default useOrganizationById;
